import React from "react";
import PropTypes from "prop-types";
import ErrorBoundary from "~/components/ErrorBoundry";
import RecurringTaskFormContainer from "~/components/tasks/CreateRecurringTaskModal/RecurringTaskFormContainer";
import RecurringTaskFromTask from "~/components/tasks/CreateRecurringTaskModal/RecurringTaskFromTask";

export const CreateRecurringTaskModal = ({ open, onClose, projectId, taskId, recurringTaskId }) => {
  return (
    <ErrorBoundary errorLocation="CreateRecurringTaskModal">
      {taskId ? (
        <RecurringTaskFromTask
          open={open}
          taskId={taskId}
          projectId={projectId}
          onClose={onClose}
        />
      ) : (
        <RecurringTaskFormContainer
          open={open}
          id={recurringTaskId}
          projectId={projectId}
          onClose={onClose}
        />
      )}
    </ErrorBoundary>
  );
};

CreateRecurringTaskModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  projectId: PropTypes.number,
  taskId: PropTypes.number,
  recurringTaskId: PropTypes.number,
};

CreateRecurringTaskModal.defaultProps = {
  open: false,
};

CreateRecurringTaskModal.displayName = "CreateRecurringTaskModal";

export default CreateRecurringTaskModal;
